import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu.component';
import { MenuItemModule } from '@app/components/menuItem/menuItem.module';
import { TranslateModule } from '@ngx-translate/core';
import { StartWithStringPipeModule } from '@shared/pipes/startWithString/startWithString.pipe.module';
import { MenuItemPipeModule } from '@shared/pipes/menuItem/menuItem.pipe.module';

@NgModule({
  imports: [CommonModule, MenuItemModule, TranslateModule, StartWithStringPipeModule, MenuItemPipeModule],
  declarations: [MenuComponent],
  exports: [MenuComponent],
})
export class MenuModule {}
